import { useSelector } from 'react-redux';
import { test, is } from 'ramda';
import { getImpressumUrl } from '../../../../selectors/settings';

export const useConnect = () => {
  const isString = is(String);
  const isUrl = test(/^https?:\/\/[^\s/$.?#].[^\s]*$/);
  const impressumUrl = useSelector(getImpressumUrl);
  const isImpressumUrlVisible = isString(impressumUrl) && isUrl(impressumUrl);
  return {
    isImpressumUrlVisible,
    impressumUrl,
  };
};
